export const SHOW_HEADER = "SHOW_HEADER"
export const HIDE_HEADER = "HIDE_HEADER"
